import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { prettyDate } from '@/helpers/date';
import IconDownload from './icon_download.svg';
import s from './index.module.scss';
import { MyLink } from '@/components/MyLink/index.jsx';
import { APP_LINKS } from '@/helpers/links.js';

export const LoanCard = ({ loan }) => {
  const { t } = useTranslation('founder-pricing');

  return (
    <div className={s.card}>
      <div className={s.table}>
        <div className={s.thead}>
          <div className={s.thead_col}>{t('fpg_page.loan')}</div>
          <div className={s.thead_col}>{t('fpg_page.outstanding_balance')}</div>
          <div className={s.thead_col}>{t('fpg_page.round')}</div>
          <div className={s.thead_col}>{t('fpg_page.fpg_option')}</div>
          <div className={s.thead_col}>{t('fpg_page.fpg_total')}</div>
          <div className={s.thead_col}>{t('fpg_page.surety_agreement')}</div>
        </div>
        <div className={s.tbody}>
          <div className={s.tbody_row}>
            <div className={s.tbody_col}>{prettyFloatMoney(loan.amount)}</div>
            <div className={s.tbody_col}>{prettyFloatMoney(loan.outstanding_balance)}</div>
            <div className={s.tbody_col}>{prettyDate(loan.fundraising_start_date)}</div>
            <div className={s.tbody_col}>{loan.fpg_option}</div>
            <div className={s.tbody_col}>{prettyFloatMoney(loan.fpg_amount)}</div>
            <div className={s.tbody_col}>
              <MyLink href={APP_LINKS.loans} className={s.download}>
                {t('fpg_page.download')}
                <img src={IconDownload} alt={t('fpg_page.download')} width={24} height={24} />
              </MyLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
